module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Select 下拉框")]), _vm._v(" "), _c('vi-select', {
    attrs: {
      "options": _vm.options,
      "selected": _vm.selected,
      "width": 220
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Html代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<!--直接使用vi-select标签-->\n<vi-select :options=\"options\" :selected.sync=\"selected\" :width=\"220\"></vi-select>\n")])]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("js代码")]), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("export default {\n    data() {\n      return {\n        options: [\n          { value: 1, text: '中国工商银行' },\n          { value: 2, text: '中国农业银行' },\n          { value: 3, text: '中国建设银行' },\n          { value: 4, text: '中国交通银行' },\n          { value: 5, text: '招商银行' },\n          { value: 6, text: '平安银行' },\n          { value: 7, text: '农村信用社' },\n          { value: 8, text: '华夏银行' },\n          { value: 9, text: '农商银行' },\n          { value: 10, text: '浦发银行' }\n        ],\n        selected: { value: 3, text: '中国建设银行' }\n      }\n    },\n    watch: {\n      selected() {\n        this.$message({\n          caption: '提示',\n          content: `你选择了${this.selected.text}`,\n          type: 'alert'\n        })\n      }\n    }\n  }\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray"
  }, [_vm._v("Props 列表")]), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table striped hovered bordered border"
  }, [_c('thead', [_c('th', [_vm._v("Prop")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Required")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Array")]), _vm._v(" "), _c('td', [_vm._v("True")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("选项列表{value: x, text: xxx}")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("selected.sync")]), _vm._v(" "), _c('td', [_vm._v("Object")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("默认选择项(options中的一项),可不传")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("width")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("False")]), _vm._v(" "), _c('td', [_vm._v("200")]), _vm._v(" "), _c('td', [_vm._v("下拉框的宽度")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40bc8c0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/select-demo.vue
// module id = 395
// module chunks = 1